import request from '@/utils/request'

// 查询登科门禁设备列表
// 说明：后端接口使用白名单方式注册（dengkeMachine.listDengkeMachines），
// 不依赖 c_service / c_route 配置，返回结构为 { total, records, dengkeMachines: [] }
export function listDengkeMachines(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/dengkeMachine.listDengkeMachines',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve({
        data: res.dengkeMachines || [],
        total: res.total || 0
      })
    }).catch(error => {
      reject(error)
    })
  })
}
